import moment from 'moment';
import { formatter } from '.';

export const validate = (validationObject) => {
  let err = {};

  validationObject.forEach((validation) => {
    const objKey = Object.keys(validation)[0];

    validation.validationRules.forEach((rule) => {
      switch (true) {
        case rule.hasOwnProperty('minLength'):
          if (!minLengthValidator(validation[objKey], rule.minLength)) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Must be at least ${rule.minLength} characters` };
          }
          break;
        case rule.isRequired:
          if (!requiredValidator(validation[objKey])) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Field is required` };
          }
          break;
        case rule.hasOwnProperty('minValue'):
          if (!minValueValidator(validation[objKey], rule.minValue)) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Value must be greater than or equal to ${formatter.toAmountDisplay(rule.minValue)}` };
          }
          break;
        case rule.hasOwnProperty('maxValue'):
          if (!maxValueValidator(validation[objKey], rule.maxValue)) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Value must be less than or equal to ${formatter.toAmountDisplay(rule.maxValue)}` };
          }
          break;
        case rule.hasOwnProperty('postalCode'):
          if (!postalCodeValidator(validation[objKey])) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Invalid postal code` };
          }
          break;
        case rule.hasOwnProperty('maxDate'):
          if (!maxDateValidator(validation[objKey], rule.maxDate)) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Date must be less than ${formatter.toDateDisplay(rule.maxDate)}` };
          }
          break;
        case rule.hasOwnProperty('minDate'):
          if (!minDateValidator(validation[objKey], rule.minDate)) {
            err = { ...err, [objKey]: rule.errorMsg ? rule.errorMsg : `Date must be greater than ${formatter.toDateDisplay(rule.minDate)}` };
          }
          break;
        default:
          break;
      }
    });
  });
  
  if (Object.keys(err)?.length) {
    const element = [...document.getElementsByClassName('input-base-error')].filter(el => el.innerText);

    if (element.length) element[0].scrollIntoView({ behavior: 'smooth' });
  }
  
  return err;
};

export const minLengthValidator = (value, minLength) => {
  return value.length >= minLength;
};

export const maxLengthValidator = (value, maxLength) => {
  return value.length < maxLength;
};

export const minValueValidator = (value, minValue) => {
  return Number(value) >= Number(minValue);
};

export const maxValueValidator = (value, maxValue) => {
  return Number(value) <= Number(maxValue);
};

export const postalCodeValidator = (value) => {
  const validPostalCodeRegex = new RegExp('[A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]');
  return validPostalCodeRegex.test(value);
}

export const minDateValidator = (date, minDate) => {
 return moment(date).isAfter(moment(minDate).subtract(1, 'day'));
}

export const maxDateValidator = (date, maxDate) => {
  return moment(date).isBefore(moment(maxDate).add(1, 'day'));
}

/**
 * Check to confirm that field is required
 *
 * @param  value
 * @return
 */
export const requiredValidator = (value) => {
  if (Date.parse(value)) return true;
  if (typeof value === 'object' && Object.keys(value).length >= 1) return true;

  return value.trim() !== '';
};

export default validate;
